<template>
    <v-container fluid class="main-body">
        <RHeader :titulo="titulo" />
            <h2 class="text-center error--text">Formulario de inscripciones cerrado.</h2><br>
            <p class="text-center">
                {{ mensaje || msg}}
            </p>
        <Footer/>
    </v-container>
</template>

<script>
    import RHeader from "../components/shared/HeaderComponent";
    import Footer from "../components/shared/Footer";
    export default {
        name: "Cerrado",
        props: ['titulo','mensaje'],
        data() {
            return {
                msg: `El formualario esta cerrado. Ponte en contacto con la organización.`
            }
        },
        components: {Footer, RHeader}
    }
</script>

<style scoped lang="scss">
    @import "./../_static/base";

</style>

